import { nb } from '@/i18n/nb';
import type { Role } from '@/types/api';
import s from './admin.module.css';

export function RolePill({ role }: { role: Role }) {
  const variant =
    role === 'admin' ? s.rolePillAdmin : role === 'owner' ? s.rolePillOwner : s.rolePillGuest;
  return <span className={`${s.rolePill} ${variant}`}>{nb.roles[role]}</span>;
}
